import Windmill from "../Components/Windmill";
import {connect} from "react-redux";

 function LeftTop(props){
    return props.setting.visible.windmill?<Windmill />:null
}

export default connect(state=>({setting: state.setting}))(LeftTop)
